export const NATIONAL_CODE_LENGTH = 10;
export const NATIONAL_CODE_REQUIRED_MSG = "کد ملی الزامی است";
export const NATIONAL_CODE_FORMAT_MSG = "کد ملی باید دقیقاً ۱۰ رقم باشد";
export const NATIONAL_CODE_INVALID_MSG = "کد ملی معتبر نیست";

const fa2enDigits = (value) =>
  String(value || "")
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

export const normalizeNationalCode = (value) => {
  const digits = fa2enDigits(value).replace(/\D/g, "");
  return digits.length === NATIONAL_CODE_LENGTH ? digits : "";
};

export const isValidIranianNationalCode = (value) => {
  const code = normalizeNationalCode(value);
  if (!code) return false;
  if ([...new Set(code)].length === 1) return false;

  let sum = 0;
  for (let i = 0; i < 9; i += 1) {
    sum += Number(code[i]) * (10 - i);
  }
  const rem = sum % 11;
  const check = rem < 2 ? rem : 11 - rem;
  return check === Number(code[9]);
};

export const validateNationalCode = (value) => {
  const normalized = fa2enDigits(value).trim();
  if (!normalized) return NATIONAL_CODE_REQUIRED_MSG;
  if (!/^\d{10}$/.test(normalized)) return NATIONAL_CODE_FORMAT_MSG;
  if (!isValidIranianNationalCode(normalized)) return NATIONAL_CODE_INVALID_MSG;
  return "";
};
